var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOnboard = function SvgOnboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.44098V13.4521C4 13.8111 4 13.9906 4.05465 14.149C4.10299 14.2891 4.18187 14.4168 4.28558 14.5227C4.40287 14.6424 4.5634 14.7227 4.88446 14.8832L10.2845 17.5832C10.5468 17.7144 10.678 17.78 10.8156 17.8058C10.9375 17.8287 11.0625 17.8287 11.1844 17.8058C11.322 17.78 11.4532 17.7144 11.7155 17.5832L17.1155 14.8832C17.4366 14.7227 17.5971 14.6424 17.7144 14.5227C17.8181 14.4168 17.897 14.2891 17.9453 14.149C18 13.9906 18 13.8111 18 13.4521V7.44098M1 5.94098L10.6422 1.11987C10.7734 1.05428 10.839 1.02148 10.9078 1.00857C10.9687 0.997142 11.0313 0.997142 11.0922 1.00857C11.161 1.02148 11.2266 1.05428 11.3578 1.11987L21 5.94098L11.3578 10.7621C11.2266 10.8277 11.161 10.8605 11.0922 10.8734C11.0313 10.8848 10.9687 10.8848 10.9078 10.8734C10.839 10.8605 10.7734 10.8277 10.6422 10.7621L1 5.94098Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOnboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/onboard.c9324595.svg";
export { ForwardRef as ReactComponent };